import { graphql, requestSubscription } from 'react-relay';
import environment from '../../environment';

const subscription = graphql`
  subscription frontSquareBoxEventDataSubscription(
    $event_id: ID!
    $current_board_id: ID!
  ) {
    frontEventData(event_id: $event_id, current_board_id: $current_board_id) {
      event_id
      current_board_id
    }
  }
`;

function frontSquareBoxEventDataSubscription(variables, onNext, onError) {
  return requestSubscription(environment, {
    subscription: subscription,
    variables: variables,
    onError,
    onNext,
  });
}

export default frontSquareBoxEventDataSubscription;
